import { DotLottieReact } from '@lottiefiles/dotlottie-react';

export interface BatAnimationConfig {
	id: string;
	className: string;
	position: {
		top?: string;
		bottom?: string;
		left?: string;
		right?: string;
	};
	delayClass?: string;
	width: string;
	height: string;
}

interface BatAnimationProps {
	animations: BatAnimationConfig[];
}

const BAT_SRC = 'https://lottie.host/e3bb3b7c-01ce-4af3-983a-7ae671a7d9b1/GwtOHyWVTU.lottie';

export default function BatAnimation({ animations }: BatAnimationProps) {
	return (
		<div className="absolute inset-0 opacity-20 pointer-events-none">
			{animations.map((bat) => (
				<div
					key={bat.id}
					className={`${bat.className} absolute ${bat.delayClass || ''}`}
					style={bat.position}
				>
					<DotLottieReact
						src={BAT_SRC}
						loop
						autoplay
						style={{ width: bat.width, height: bat.height }}
					/>
				</div>
			))}
		</div>
	);
}
